import React from 'react';
import clsx from 'clsx';
import style from './SquareEdit-styles.module.scss';
import { IconButton } from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import SButton from '../SButton/SButton';

const SquareEdit = ({ onPress, className, ...props }) => {
  return (
    <SButton
      variant={'tertiary'}
      onClick={onPress}
      className={clsx(style['button-container'], className)}
      {...props}
    >
      <Edit style={{ color: '#8B94AC' }} />
    </SButton>
  );
};

export default SquareEdit;
